import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b938fbf8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "form-cont" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "form-headline" }, " Möchtest du ein TV-Paket dazubuchen? ", -1))
const _hoisted_3 = { class: "form-fields" }
const _hoisted_4 = {
  key: 0,
  class: "options-and-addons"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, " Zusatzoptionen ", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, " Erweitere dein Standardpaket um weitere Optionen für mehr Entertainment. ", -1))

import Product from '@/classes/Product';
import AppRadioCardButtons from '@/components/inputs/AppRadioCardButtons.vue';
import TelevisionAddonCard from '@/components/product/TelevisionAddonCard.vue';
import TelevisionOptionCard from '@/components/product/TelevisionOptionCard.vue';
import TelevisionPackageCard from '@/components/product/TelevisionPackageCard.vue';
import AppOrderActions from '@/components/order/order/AppOrderActions.vue';
import TelevisionPackageInterface from '@/interfaces/TelevisionPackageInterface';
import { watch } from 'vue';
import TelevisionProducts from '../../../../public/TelevisionProducts.json';


export default /*#__PURE__*/_defineComponent({
  __name: 'InternetConfigTelevision',
  props: /*#__PURE__*/_mergeModels({
    product: {},
    priceParams: {}
  }, {
    "modelValue": {},
    "modelModifiers": {},
  }),
  emits: /*#__PURE__*/_mergeModels(['previous', 'next'], ["update:modelValue"]),
  setup(__props: any, { emit: __emit }) {

const props = __props;

const form = _useModel<Record<string, any>>(__props, "modelValue");
const emit = __emit;

const customerType = props.priceParams?.customerType || 'private';

const products = TelevisionProducts.products as TelevisionPackageInterface[];
const options = TelevisionProducts.options as unknown as TelevisionPackageInterface[];
const addons = TelevisionProducts.addons as unknown as TelevisionPackageInterface[];

const packageOptions = products.map((p) => ({ label: p.name, value: p.id, customerType: p.customerType })).filter((option) => !Array.isArray(option.customerType) || option.customerType.includes(customerType));

const packageOptionOptions = options.map((p) => ({ label: p.name, value: p.id, customerType: p.customerType })).filter((option) => !Array.isArray(option.customerType) || option.customerType.includes(customerType));
const packageAddonsOptions = addons.map((p) => ({
  label: p.name, value: p.id, excludes: p.price.excludes || [], customerType: p.customerType,
})).filter((option) => !Array.isArray(option.customerType) || option.customerType.includes(customerType));
const getPackageById = (packageId: string): TelevisionPackageInterface => {
  const foundPackage = products.find((p) => p.id === packageId) as TelevisionPackageInterface;

  return foundPackage;
};

const getPackageOptionById = (optionId: string): TelevisionPackageInterface => {
  const foundPackageOption = options.find((o) => o.id === optionId) as TelevisionPackageInterface;

  return foundPackageOption;
};

const getPackageAddonById = (addonId: string): TelevisionPackageInterface => {
  const foundPackageAddon = addons.find((a) => a.id === addonId) as TelevisionPackageInterface;

  return foundPackageAddon;
};

watch(() => form.value.television.package, () => {
  setTimeout(() => {
    window.runIoEqualize();
  }, 50);
}, {
  immediate: true,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(AppRadioCardButtons, {
        class: "radio-packages mb-0",
        options: _unref(packageOptions),
        modelValue: form.value.television.package,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.value.television.package) = $event)),
        toggle: "",
        "grid-template": {
            xs: '1fr',
            sm: '1fr 1fr',
            lg: '1fr',
            xxl: '1fr 1fr',
          }
      }, {
        option: _withCtx(({ option, selected, disabled }) => [
          _createVNode(TelevisionPackageCard, {
            class: _normalizeClass({ selected, disabled }),
            package: getPackageById(option.value)
          }, null, 8, ["class", "package"])
        ]),
        _: 1
      }, 8, ["options", "modelValue"]),
      (form.value.television.package === 'tv-2')
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _hoisted_5,
            _hoisted_6,
            _createVNode(AppRadioCardButtons, {
              class: "radio-options",
              options: _unref(packageOptionOptions),
              modelValue: form.value.television.option,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.value.television.option) = $event)),
              toggle: "",
              "grid-template": {
              xs: '1fr',
              sm: '1fr 1fr',
              lg: '1fr',
              xxl: '1fr 1fr',
            }
            }, {
              option: _withCtx(({ option, selected, disabled }) => [
                _createVNode(TelevisionOptionCard, {
                  small: "",
                  class: _normalizeClass({ selected, disabled }),
                  option: getPackageOptionById(option.value)
                }, null, 8, ["class", "option"])
              ]),
              _: 1
            }, 8, ["options", "modelValue"]),
            _createVNode(AppRadioCardButtons, {
              class: "radio-addons mb-0",
              options: _unref(packageAddonsOptions),
              modelValue: form.value.television.addons,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.value.television.addons) = $event)),
              multiple: "",
              "grid-template": {
              xs: '1fr',
              sm: '1fr 1fr',
              xxl: '1fr 1fr 1fr 1fr',
            }
            }, {
              option: _withCtx(({ option, selected, disabled }) => [
                _createVNode(TelevisionAddonCard, {
                  small: "",
                  class: _normalizeClass({ selected, disabled }),
                  addon: getPackageAddonById(option.value)
                }, null, 8, ["class", "addon"])
              ]),
              _: 1
            }, 8, ["options", "modelValue"])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", {
      class: _normalizeClass({
          'bg-gray': form.value.television.package === 'tv-2',
        })
    }, [
      _createVNode(AppOrderActions, {
        labels: {
            previous: 'Zurück',
            next: form.value.television.package ? 'In den Warenkorb' : 'Ohne TV-Paket weiter',
          },
        onPrevious: _cache[3] || (_cache[3] = ($event: any) => (emit('previous'))),
        onNext: _cache[4] || (_cache[4] = ($event: any) => (emit('next'))),
        "color-next": _ctx.product.branch,
        "hide-required-hint": ""
      }, null, 8, ["labels", "color-next"])
    ], 2)
  ]))
}
}

})